import type React from "react";
import { lazy, Suspense } from "react";

const LazyCarlStreamInitializer = lazy(() =>
  import(`@granular/fabric3-library-carl-components`).then((module) => ({
    default: module.StreamResponseSetup,
  })),
);

/**
 * StreamInitializer loads a component that opens up the socket for the CARL
 * chit chat bot. This is like a singleton—we want one instance of this
 * so that we don't end up with issues of connecting twice and getting
 * double requests/responses. oops. 🙊
 */
export const StreamInitializer: React.FC = () => {
  // No need to render anything in the fallback. We just want
  // it to silently await the loading.
  return (
    <Suspense fallback={undefined}>
      <LazyCarlStreamInitializer />
    </Suspense>
  );
};
